module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._core-js@2.5.0@core-js/modules/_fails.js
// module id = ../../../../._core-js@2.5.0@core-js/modules/_fails.js
// module chunks = 2